// extracted by mini-css-extract-plugin
export default {"content":"content___MWrK5"};